
import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../contexts/AuthContext';
import config from '../../config';
import styles from './CustomerPastOrder.module.css';

const CustomerPastOrders = () => {
  const { user, token } = useContext(AuthContext);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  useEffect(() => {
    if (!user || !token) return;

    const fetchPastOrders = async () => {
      try {
        const res = await axios.get(`${config.backendUrl}/api/orders/my-orders`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const pastOrders = res.data.filter(order => order.status === 'Confirmed Delivered');
        setOrders(pastOrders);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchPastOrders();
    const interval = setInterval(fetchPastOrders, 20000);
    return () => clearInterval(interval);
  }, [user, token]);

  const toggleExpand = (orderId) => {
    setExpandedOrderId((prev) => (prev === orderId ? null : orderId));
  };

  if (loading) return (
    <div className={styles.container}>
      <div className={styles.skeletonGrid}>
        {[...Array(6)].map((_, i) => (
          <div key={i} className={styles.skeletonCard}>
            <div className={`${styles.skeletonBar} ${styles.wide}`}></div>
            <div className={styles.skeletonSpacer}></div>
            <div className={styles.skeletonBar}></div>
            <div className={styles.skeletonSpacer}></div>
            <div className={`${styles.skeletonBar} ${styles.thin}`}></div>
            <div className={styles.skeletonSpacer}></div>
            <div className={`${styles.skeletonBar} ${styles.thin}`}></div>
          </div>
        ))}
      </div>
    </div>
  );
  if (orders.length === 0) return <p className={styles.noOrders}>No past orders found.</p>;

  return (
    <div className={styles.container}>

      {/* Title removed */}
      <div className={styles.ordersList}>
        
        {orders.map((order) => {
          const isExpanded = expandedOrderId === order._id;
          const deliveryFee = order.delivery?.fee || 0;
          const totalWithDelivery = order.total + deliveryFee;

          return (
            <div key={order._id} className={styles.orderCard}>
              <div className={styles.orderHeader}>
                
                <div className={styles.orderSummary}>
                  <p className={styles.orderInfo}>
                    <strong>Date:</strong> {new Date(order.deliveredAt || order.updatedAt || order.createdAt).toLocaleDateString()}
                  </p>
                  <p className={styles.orderInfo}>
                    <strong>Order #:</strong> {order.orderId}
                  </p>
                  <p className={styles.orderInfo}>
                    <strong>Amount:</strong> KES {totalWithDelivery} <small>(Order: {order.total} + Delivery: {deliveryFee})</small>
                  </p>
                </div>

                <button
                  onClick={() => toggleExpand(order._id)}
                  className={`${styles.button} ${styles.viewButton}`}
                >
                  {isExpanded ? 'Hide' : 'View'}
                </button>
              </div>

              {isExpanded && (
                <div className={styles.expandedSection}>
                  <p className={styles.orderDetail}><strong>Payment Method:</strong> {order.paymentMethod}</p>
                  <p className={styles.orderDetail}><strong>Payment Status:</strong> {order.paymentStatus}</p>
                  <p className={styles.orderDetail}>
                    <strong>Delivery:</strong> {order.delivery.town}, {order.delivery.location} ({order.delivery.option})
                  </p>

                  <h4 className={styles.itemsTitle}>Items:</h4>
                  <ul className={styles.itemsList}>
                    {order.items.map((item) => (
                      <li key={item._id} className={styles.item}>
                        <strong>Product:</strong> {item.product?.name || 'Unknown'}<br />
                        <strong>Shop:</strong> {item.shop?.shopName || 'Unknown'}<br />
                        <strong>Qty:</strong> {item.quantity} — <strong>Price:</strong> KES {item.price}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CustomerPastOrders;
